import { styled, Menu, menuClasses } from '@mui/material';

export const ActionOrderMenuContainerMenu = styled(Menu)({
  [`& .${menuClasses.paper}`]: {
    border: '1px solid #d3d4d5',
  },
});
